import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/hr_absence_request'

const deleteAbsenceRequest = async function(id) {
    try {
        let response = await axios.delete(route + '/' + id)
        return response.data
    } catch (error) {
        return error.response.data
    }
}

export { deleteAbsenceRequest }
